import {fromJS} from 'immutable';
import _ from 'lodash';
import {calculateResourceSummary} from '@sakari-io/staza-common';

import {
  FETCH_JOBS,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILED,
  FETCH_JOB_SUCCESS,
  FETCH_JOB_FAILED,
  SET_JOB,
  SET_REFERENCE,
  SET_CUSTOMER,
  SET_PRIMARY_CONTACT,
  SET_START,
  SET_END,
  SET_DESCRIPTION,
  SET_NOTES,
  SET_JOB_PROFILE,
  SET_TASK_PROFILES,
  ADD_TASK_PROFILE,
  REMOVE_TASK_PROFILE,
  ADD_PREFERRED_ITEM,
  REMOVE_PREFERRED_ITEM,
  SET_PREFERRED_ITEMS,
  ADD_TAG,
  REMOVE_TAG,
  ADD_RESOURCES,
  ADD_RESOURCE,
  REMOVE_RESOURCE,
  SET_RESOURCE_EMPLOYEE,
  ADD_STAGE,
  REMOVE_STAGE,
  SET_ORIGIN,
  SET_DESTINATION,
} from '../actions/jobs';
import {UPLOAD_TASKS_SUCCESS} from '../actions/tasks';

import { saveJobRoutine, removeJobRoutine, saveJobResourcesRoutine, removeTasksRoutine} from '../routines';
import {updateOrAdd, remove, updateOrAddMap, removeMap} from './helper';

const initialState = fromJS({
  jobs: [],
  job: {
    resources: [],
    exceptions: {},
    start: new Date(),
    end: new Date(),
  },
  loading: false,
  saving: false,
});

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    case FETCH_JOBS:
      return state.set('loading', true);
    case FETCH_JOBS_SUCCESS:
      return state.set('jobs', fromJS(action.jobs || [])).set('loading', false);
    case FETCH_JOBS_FAILED:
      return state.set('error', action.error).set('loading', false);
    case FETCH_JOB_SUCCESS:
      return state.set('job', fromJS(action.job)).set('loading', false);
    case FETCH_JOB_FAILED:
      return state.set('error', action.error).set('loading', false);
    case SET_JOB:
      return state.set('job', fromJS(action.job));
    case SET_CUSTOMER:
      return state
        .setIn(['job', 'customerId'], action.customer.id)
        .setIn(['job', 'customer'], action.customer)
        .setIn(['job', 'primaryContact'], null);
    case SET_REFERENCE:
      return state.setIn(['job', 'reference'], action.reference);
    case SET_PRIMARY_CONTACT:
      return state
        .setIn(['job', 'primaryContactId'], action.primaryContact.id)
        .setIn(['job', 'primaryContact'], action.primaryContact);
    case SET_START:
      return state.setIn(['job', 'start'], action.start);
    case SET_END:
      return state.setIn(['job', 'end'], action.end);
    case SET_ORIGIN:
      return state
        .setIn(['job', 'origin'], action.origin)
        .setIn(['job', 'originId'], action.origin.id);
    case SET_DESTINATION:
      return state
        .setIn(['job', 'destination'], action.destination)
        .setIn(['job', 'destinationId'], action.destination.id);
    case SET_DESCRIPTION:
      return state.setIn(['job', 'description'], action.description);
    case SET_NOTES:
      return state.setIn(['job', 'notes'], action.notes);
    case ADD_TAG:
      return state.updateIn(['job', 'tags'], updateOrAdd(fromJS(action.tag), (obj) => obj)).set('loading', false);
    case REMOVE_TAG:
      return state.updateIn(['job', 'tags'], remove(action.tag, (obj) => obj))
        .set('loading', false);
    case SET_JOB_PROFILE:
      return state.setIn(['job', 'profile'], fromJS(action.jobProfile));
    case SET_TASK_PROFILES:
      return state.setIn(['job', 'taskProfiles'], fromJS(action.taskProfiles));
    case ADD_PREFERRED_ITEM:
      return state.updateIn(['job', 'preferredItems'], updateOrAdd(fromJS(action.item))).set('loading', false);
    case REMOVE_PREFERRED_ITEM:
      return state.updateIn(['job', 'preferredItems'], remove(fromJS(action.item)))
        .set('loading', false);
    case SET_PREFERRED_ITEMS :
      return state.setIn(['job', 'preferredItems'], fromJS(action.itemTypes));
    case ADD_TASK_PROFILE:
      return state.updateIn(['job', 'taskProfiles'], updateOrAdd(fromJS(action.taskProfile))).set('loading', false);
    case REMOVE_TASK_PROFILE:
      return state.updateIn(['job', 'taskProfiles'], remove(fromJS(action.taskProfile)))
        .set('loading', false);
    case ADD_RESOURCES:
      const newResources = action.resources.reduce((res, resource) => {
        res[resource.id] = resource;
        return res;
      }, {});

      return state.mergeIn(['job', 'resources'], fromJS(newResources));
    case ADD_RESOURCE:
      return state.updateIn(['job', 'resources'], updateOrAddMap(fromJS(action.resource)));
    case REMOVE_RESOURCE:
      console.log('job', state.get('job').toJS());
      console.log('action', action);
      return state.updateIn(['job', 'resources'], removeMap(fromJS(action.resource)))
        .updateIn(['jobs'], (jobs) => {
          return jobs.map((job) => {
            if (job.get('id') === action.job.id) {
              return job.updateIn(['resources'], removeMap(fromJS(action.resource)));
            }

            return job;
          });
        });
    case SET_RESOURCE_EMPLOYEE:
      if (action.employee) {
        return state.setIn(['job', 'resources', action.resource.id, 'employeeId'], action.employee.id)
          .setIn(['job', 'resources', action.resource.id, 'employee'], action.employee);
      } else {
        return state.deleteIn(['job', 'resources', action.resource.id, 'employeeId'])
          .deleteIn(['job', 'resources', action.resource.id, 'employee']);
      }
    case ADD_STAGE:
      return state.set('loading', false)
        .updateIn(['job', 'stages'], updateOrAdd(fromJS(action.stage)));
    case REMOVE_STAGE:
      return state.updateIn(['job', 'stages'], remove(fromJS(action.stage)));
    case saveJobRoutine.TRIGGER:
      return state;
    case saveJobRoutine.SUCCESS:
      return state
        .updateIn(['jobs'], updateOrAdd(fromJS(action.payload.job)))
        .set('job', fromJS(action.payload.job)).set('saving', false);
    case saveJobRoutine.FAILURE:
      return state.set('error', action.error).set('saving', false);
    case saveJobRoutine.FULFILL:
      return state;
    case saveJobResourcesRoutine.FULFILL:
      const dates = calculateResourceSummary(state.get('job').toJS());
      const jobId = state.get('job').get('id');
      return state.updateIn(['jobs'], (jobs) => {
        return jobs.map((job) => {
          if (job.get('id') === jobId) {
            return state.get('job').setIn(['dates'], fromJS(dates));
          }

          return job;
        });
      });
    case removeJobRoutine.SUCCESS:
      return state.updateIn(['jobs'], remove(fromJS(action.payload.job)));
    case removeJobRoutine.FAILURE:
      return state.set('error', action.error);
    case UPLOAD_TASKS_SUCCESS:
      console.log('UPLOAD_TASKS_SUCCESS', action);
      // console.log()
      return state.updateIn(['jobs'], (jobs) => {
        return jobs.map((job) => {
          if (job.get('id') === action.job.id) {
            console.log('action job id dound');
            return job.updateIn(['tasks', 'count'], (count = 0) => {
              console.log('counts', count, _.keys(action.tasks).length, count + _.keys(action.tasks).length);
              return count + _.keys(action.tasks).length;
            });
          }

          return job;
        });
      }).updateIn(['job', 'tasks', 'count'], (count = 0) => count + _.keys(action.tasks).length);
    case removeTasksRoutine.SUCCESS:
      return state.updateIn(['job', 'tasks', 'count'], (count) => Math.max((count || 0) - action.payload.request.tasks.length, 0))
        .updateIn(['jobs'], (jobs) => {
          const jId = action.payload.request.tasks[0].jobId;
          console.log('jId', jId);
          return jobs.map((job) => {
            console.log('job.getid', job.get('id'));
            if (job.get('id') === jId) {
              return job.setIn(['tasks', 'count'], job.getIn(['tasks', 'count']) - action.payload.request.tasks.length);
            }

            return job;
          });
        });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/jobs.js